import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/style-component/components/cardIconStyle.js";
import PropTypes from "prop-types";
import React from "react";
import { estilos } from "assets/jss/style-component/components/estiloComponente.js";

const useStyles = makeStyles(styles);

export default function CardIcon(props) {
  const { children, ...rest } = props;
  const cardClasses = estilos(useStyles(), props, "icono");

  return (
    <div className={cardClasses} {...rest}>
      {children}
    </div>
  );
}

CardIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.oneOf([
    "warning",
    "success",
    "danger",
    "info",
    "primary",
    "rose"
  ]),
  children: PropTypes.node
};
